import React from "react";
import { labelMes, ultimosMeses } from "./slaFormat";

interface Props {
  id: string;
  value: string | null;
  onChange: (month: string | null) => void;
}

/** Seletor de mês do SLA: 12 meses + "Todos os meses" (null). */
const MonthSelect: React.FC<Props> = ({ id, value, onChange }) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-sm font-semibold text-gray-700 dark:text-gray-300">
      Mês
    </label>
    <select
      id={id}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)}
      className="rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm text-navy-700 dark:border-white/15 dark:bg-navy-900 dark:text-white"
    >
      <option value="">Todos os meses</option>
      {ultimosMeses().map((m) => (
        <option key={m} value={m}>
          {labelMes(m)}
        </option>
      ))}
    </select>
  </div>
);

export default MonthSelect;
